module.exports = __webpack_public_path__ + "static/media/golden-ring_720x480.3ea73e44.jpg";